export default "__VITE_PUBLIC_ASSET__3648b76f__"